import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  templateUrl: 'advanced-chips-input.component.html',
  standalone: false,
})
export class AdvancedChipsInputComponent extends AbstractAdvancedInput implements OnInit {
  @ViewChild('chipsInput') chipsInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  @Input() set currentValue(val: any[]) {
    this._value = new Set(val || []);
  }

  declare public _value: Set<any>;

  public set value(val: Set<any>) {
    this._value = val;
    this.emitCurrentValueChange();
  }

  public get value() {
    return this._value;
  }

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public chipsInputCtrl = new UntypedFormControl();
  filteredValues$: Observable<any[]>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Defer using `this.configuration` until inputs have been set by Angular
    this.filteredValues$ = this.chipsInputCtrl.valueChanges.pipe(
      startWith(null),
      map((item: string | null) => {
        const configurationValues = ((this.configuration as any)?.values || [])
          .slice()
          .filter(option => !this._value.has(option.key));
        return item ? this._filter(item) : configurationValues;
      })
    );
  }

  private emitCurrentValueChange() {
    this.currentValueChange.emit(Array.from(this._value));
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.chipInput.inputElement;
      const value = this.getValueFromEvent(event);
      // Add our item
      if ((value || '').trim()) {
        this._value.add(value);
        this.emitCurrentValueChange();
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.chipsInputCtrl.setValue(null);
    }
  }
  protected getValueFromEvent(event: MatChipInputEvent) {
    return event.value;
  }

  remove(item: any): void {
    this.value.delete(item);
    this.chipsInputCtrl.setValue(null);
    this.emitCurrentValueChange();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.chipsInput.nativeElement.value = '';
    this.chipsInputCtrl.setValue(null);
    this._value.add(event.option.value);
    this.emitCurrentValueChange();
  }

  private _filter(value: string): string[] {
    const term = value.toLocaleLowerCase();
    return (this.configuration.values || []).filter(
      option => !this._value.has(option.key) && option.key.toLowerCase().indexOf(term) === 0
    );
  }
}

@Component({
  templateUrl: 'advanced-chips-input.component.html',
  standalone: false,
})
export class AdvancedStrictChipsInputComponent extends AdvancedChipsInputComponent {
  protected getValueFromEvent(event: MatChipInputEvent) {
    const value = this.configuration.values.find(x => x.key === event.value);
    return value ? value.key : null;
  }
}
